// extracted by mini-css-extract-plugin
export default {"trainCourseApplication":"styles_trainCourseApplication__OxIb9","iframeContainer":"styles_iframeContainer__JJ1FU"};